import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('Option', {
    error: (
        <FormattedMessage
            id='front-app/Option/Notification/Error:title'
            defaultMessage='Option Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/Option/Notification/Warning:title'
            defaultMessage='Option Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/Option/Notification/Info:title'
            defaultMessage='Option Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/Option/Notification/Info:title'
            defaultMessage='Option Info'
        />
    ),
});

export const optionNotifications = {
    createdSuccessfully: notification.success(appNotification.texts.createdSuccessfully),
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
